/* ==========================================================================
   Elevate Floors — Seção 09: Why choose us

   O CSS já abre o corpo com max-height:260px, que funciona como piso de
   segurança se este script não carregar. Aqui a altura exata é medida e
   escrita, então nenhum texto fica cortado por mais longo que seja.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section._efWhyBound) return;
    section._efWhyBound = true;

    var items = Array.prototype.slice.call(section.querySelectorAll('[data-item]'));
    if (!items.length) return;

    function closeAll() {
      items.forEach(function (it) {
        it.classList.remove('is-open');
        var h = it.querySelector('.ef-why__head');
        var b = it.querySelector('.ef-why__body');
        if (h) h.setAttribute('aria-expanded', 'false');
        if (b) b.style.maxHeight = '';
      });
    }

    items.forEach(function (item) {
      var head = item.querySelector('.ef-why__head');
      var body = item.querySelector('.ef-why__body');
      if (!head) return;

      head.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        closeAll();                       // um por vez
        if (!willOpen) return;            // clicar no aberto fecha
        item.classList.add('is-open');
        head.setAttribute('aria-expanded', 'true');
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      });
    });

    // a quebra de linha muda a altura ao redimensionar
    function fitOpen() {
      var open = section.querySelector('.ef-why__item.is-open .ef-why__body');
      if (open) open.style.maxHeight = open.scrollHeight + 'px';
    }
    window.addEventListener('resize', fitOpen);

    /* Item que já vem aberto do Liquid: o CSS o mostra com o teto de 260px;
       aqui ele recebe a altura exata. De novo no load, porque a fonte muda a
       quebra das linhas depois do primeiro cálculo. */
    fitOpen();
    window.addEventListener('load', fitOpen);
  }

  function init() {
    document.querySelectorAll('[data-why]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
